<template>
  <v-sheet color="blue-grey-lighten-5">
    <v-container>
      <v-row>
        <v-col>
          <h2 class="text-h3 text-md-h2 text-center font-weight-bold mb-3">
            Repair Gallery
          </h2>

          <p class="text-body-1 text-center">
            Check out before and after photos of some of our auto collision
            repairs!
          </p>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <v-card color="transparent" tile variant="flat">
            <v-container fluid>
              <v-row>
                <v-col>
                  <v-window v-model="repairWindow" direction="vertical">
                    <v-window-item v-for="(shot, i) in repairShots" :key="i">
                      <v-sheet color="blue-grey-lighten-5" height="100%" tile>
                        <v-container fluid>
                          <v-row>
                            <v-col
                              class="d-flex justify-center justify-md-end"
                              cols="12"
                              md="6"
                            >
                              <v-img
                                :position="shot.before.position"
                                :src="shot.before.image"
                                aspect-ratio="1"
                                cover
                                max-width="600"
                              />
                            </v-col>
                            <v-col
                              class="d-flex justify-center justify-md-start"
                              cols="12"
                              md="6"
                            >
                              <v-img
                                :position="shot.after.position"
                                :src="shot.after.image"
                                aspect-ratio="1"
                                cover
                                max-width="600"
                              />
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-sheet>
                    </v-window-item>
                  </v-window>
                </v-col>
              </v-row>
            </v-container>

            <v-card-actions class="justify-center">
              <v-item-group
                v-model="repairWindow"
                class="text-center"
                mandatory
              >
                <v-item
                  v-for="n in repairShots.length"
                  :key="`btn-${n}`"
                  v-slot="{ isSelected, select }"
                >
                  <v-btn :active="isSelected" class="mx-2" icon @click="select">
                    <v-icon>{{ mdiRecord }}</v-icon>
                  </v-btn>
                </v-item>
              </v-item-group>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { mdiRecord } from '@mdi/js'

import repairFordFiestaBefore from '#root/assets/images/repair-ford-fiesta-before.jpg'
import repairFordFiestaAfter from '#root/assets/images/repair-ford-fiesta-after.jpg'
import repairMercedesGlsBefore from '#root/assets/images/repair-mercedes-gls-before.jpg'
import repairMercedesGlsAfter from '#root/assets/images/repair-mercedes-gls-after.jpg'
import repairToyotaRav4Before from '#root/assets/images/repair-toyota-rav4-before.jpg'
import repairToyotaRav4After from '#root/assets/images/repair-toyota-rav4-after.jpg'
import repairYarisBefore from '#root/assets/images/repair-yaris-before.jpg'
import repairYarisAfter from '#root/assets/images/repair-yaris-after.jpg'

const repairShots = [
  {
    before: {
      image: repairFordFiestaBefore,
      position: 'left 20% center'
    },
    after: {
      image: repairFordFiestaAfter,
      position: 'left 20% top 20%'
    }
  },
  {
    before: {
      image: repairMercedesGlsBefore,
      position: 'left 20% center'
    },
    after: {
      image: repairMercedesGlsAfter,
      position: 'left 5% center'
    }
  },
  {
    before: {
      image: repairToyotaRav4Before,
      position: 'left 40% center'
    },
    after: {
      image: repairToyotaRav4After,
      position: 'left 20% center'
    }
  },
  {
    before: {
      image: repairYarisBefore,
      position: 'left 60% center'
    },
    after: {
      image: repairYarisAfter,
      position: 'center top 20%'
    }
  }
]
const repairWindow = ref(0)
</script>
